import styled from '@emotion/styled';
import { MenuItem, Select } from '@material-ui/core';
import { createElement, FC } from 'react';
import { useMount } from 'react-use';

import { InputtingCreativeFormatsFilter } from '../../../types/InputtingCreativeFormatsFilter';
import CreativeFormatCreativeTypeLabel from '../CreativeFormatCreativeTypeLabel';

type Props = {
  isDisabled?: boolean;
  inputtingCreativeFormatsFilter: InputtingCreativeFormatsFilter;
  selectedCreativeTypeIndex: Array<string | null> | null;
  onMountFilter?: () => void;
  onChangeSelectedCreativeType: (value: string) => void;
  className?: string;
};

const SelectCreativeTypes: FC<Props> = ({
  isDisabled = false, // Resize追加時にCreativeTypeは変更させないため
  inputtingCreativeFormatsFilter,
  selectedCreativeTypeIndex,
  onChangeSelectedCreativeType,
  onMountFilter, // Resize追加時にのみListのフィルタリングを実行する
  className,
}) => {
  useMount(() => {
    if (onMountFilter) {
      onMountFilter();
    }
  });

  return (
    <Selects
      disabled={isDisabled}
      value={selectedCreativeTypeIndex && selectedCreativeTypeIndex.length ? selectedCreativeTypeIndex : 'all'}
      onChange={(e) => onChangeSelectedCreativeType(`${e.target.value}`)}
      className={className}
    >
      {[
        <MenuItem key={`creativeType-all`} value={'all'}>
          All
        </MenuItem>,
        ...inputtingCreativeFormatsFilter.creativeTypes.map((creativeType, index) => (
          <MenuItem key={`${index}-${creativeType.creativeType.id}`} value={index}>
            <CreativeFormatCreativeTypeLabel creativeType={creativeType.creativeType} />
          </MenuItem>
        )),
      ]}
    </Selects>
  );
};

const Selects = styled(Select)({
  width: '100%',
});

export default SelectCreativeTypes;
